import { styled } from "styled-components";

export const ProfileEditInputTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
